const MedicationBlob = () => {
  return (
    <svg
      width="160"
      height="125"
      viewBox="0 0 160 125"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_5622_26054)">
        <path
          d="M5.37961 40.5733C-0.391955 29.8133 8.00179 15.0021 20.1563 16.2912C37.9557 18.1789 58.6082 19.8035 71.6852 18.9928C88.3107 17.962 115.413 12.4627 135.664 7.91959C147.351 5.29766 157.701 16.329 154.095 27.7366L129.06 106.938C127.1 113.137 120.94 117.014 114.494 116.103L12.0575 101.633C1.88091 100.196 -3.0825 88.0975 2.03853 79.1981C6.70994 71.08 10.7988 61.9741 10.5548 55.2778C10.4091 51.2804 8.30737 46.0316 5.37961 40.5733Z"
          fill="#FFCC00"
        />
        <foreignObject x="17.8641" y="16.5683" width="129.882" height="100.894">
          <div
            style={{ backdropFilter: 'blur(5.51px)', clipPath: 'url(#bgblur_1_5622_26054_clip_path)', height: '100%', width: '100%' }}
          ></div>
        </foreignObject>
        <g
          filter="url(#filter0_d_5622_26054)"
          data-figma-bg-blur-radius="11.0118"
        >
          <rect
            x="29.1582"
            y="27.5801"
            width="107.294"
            height="77.6471"
            rx="11.2941"
            fill="white"
            fill-opacity="0.01"
            shape-rendering="crispEdges"
          />
          <rect
            x="29.5111"
            y="27.933"
            width="106.588"
            height="76.9412"
            rx="10.9412"
            stroke="white"
            stroke-width="0.705882"
            shape-rendering="crispEdges"
          />
        </g>
        <rect
          x="33.3936"
          y="31.8125"
          width="98.8235"
          height="69.1765"
          rx="7.05882"
          fill="#EFEEFF"
        />
        <rect
          x="37.6289"
          y="36.0469"
          width="90.353"
          height="16.9412"
          rx="2.82353"
          fill="white"
        />
        <rect
          x="41.3936"
          y="41.9316"
          width="48.9412"
          height="5.64706"
          rx="2.82353"
          fill="#EFEEFF"
        />
        <rect
          x="104.923"
          y="41.9316"
          width="19.2941"
          height="5.64706"
          rx="2.82353"
          fill="#CCCCFF"
        />
        <rect
          x="40.4531"
          y="55.8125"
          width="84.7059"
          height="12.7059"
          rx="2.82353"
          fill="white"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M116.347 58.4982C116.517 58.328 116.748 58.2324 116.989 58.2324H119.21C119.451 58.2324 119.682 58.328 119.852 58.4982L121.767 60.4127C121.937 60.5829 122.033 60.8138 122.033 61.0545V63.2759C122.033 63.5166 121.937 63.7475 121.767 63.9177L119.852 65.8321C119.682 66.0023 119.451 66.0979 119.21 66.0979H116.989C116.748 66.0979 116.517 66.0023 116.347 65.8321L114.433 63.9177C114.263 63.7475 114.167 63.5166 114.167 63.2759V61.0545C114.167 60.8138 114.263 60.5829 114.433 60.4127L116.347 58.4982ZM118.1 59.8207C118.35 59.8207 118.554 60.0238 118.554 60.2744V62.2408C118.554 62.4914 118.35 62.6946 118.1 62.6946C117.849 62.6946 117.646 62.4914 117.646 62.2408V60.2744C117.646 60.0238 117.849 59.8207 118.1 59.8207ZM118.705 63.9047C118.705 64.2388 118.434 64.5097 118.1 64.5097C117.766 64.5097 117.495 64.2388 117.495 63.9047C117.495 63.5705 117.766 63.2996 118.1 63.2996C118.434 63.2996 118.705 63.5705 118.705 63.9047Z"
          fill="#FF0099"
        />
        <rect
          x="54.5703"
          y="60.7559"
          width="24.4706"
          height="2.82353"
          rx="1.41176"
          fill="#EFEEFF"
        />
        <rect
          x="101.158"
          y="60.7559"
          width="9.41177"
          height="2.82353"
          rx="1.41176"
          fill="#EFEEFF"
        />
        <rect
          x="40.4531"
          y="69.9316"
          width="84.7059"
          height="12.7059"
          rx="2.82353"
          fill="white"
        />
        <rect
          x="54.5703"
          y="74.873"
          width="35.7647"
          height="2.82353"
          rx="1.41176"
          fill="#EFEEFF"
        />
        <rect
          x="101.158"
          y="74.873"
          width="9.41177"
          height="2.82353"
          rx="1.41176"
          fill="#EFEEFF"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M118.1 80.0489C120.179 80.0489 121.864 78.3634 121.864 76.2842C121.864 74.205 120.179 72.5195 118.1 72.5195C116.02 72.5195 114.335 74.205 114.335 76.2842C114.335 78.3634 116.02 80.0489 118.1 80.0489ZM118.436 74.4019C118.436 74.2162 118.285 74.0657 118.1 74.0657C117.914 74.0657 117.764 74.2162 117.764 74.4019V76.2842C117.764 76.4699 117.914 76.6204 118.1 76.6204H119.444C119.63 76.6204 119.78 76.4699 119.78 76.2842C119.78 76.0986 119.63 75.9481 119.444 75.9481H118.436V74.4019Z"
          fill="#FFCC00"
        />
        <rect
          x="40.4531"
          y="84.0488"
          width="84.7059"
          height="12.7059"
          rx="2.82353"
          fill="white"
        />
        <rect
          x="54.5703"
          y="88.9902"
          width="29.1765"
          height="2.82353"
          rx="1.41176"
          fill="#EFEEFF"
        />
        <rect
          x="101.158"
          y="88.9902"
          width="9.41177"
          height="2.82353"
          rx="1.41176"
          fill="#EFEEFF"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M115.204 86.6367H120.996C121.475 86.6367 121.864 87.0257 121.864 87.5055V93.2974C121.864 93.7771 121.475 94.1661 120.996 94.1661H115.204C114.724 94.1661 114.335 93.7771 114.335 93.2974V87.5055C114.335 87.0257 114.724 86.6367 115.204 86.6367ZM120.128 89.3696C120.278 89.1823 120.248 88.9089 120.061 88.7591C119.873 88.6092 119.6 88.6396 119.45 88.8269L117.396 91.3941L116.575 90.7779C116.383 90.634 116.11 90.6728 115.967 90.8648C115.823 91.0567 115.861 91.329 116.053 91.4729L117.212 92.3417C117.399 92.4825 117.665 92.4487 117.812 92.2655L120.128 89.3696Z"
          fill="#330066"
        />
        <foreignObject x="7.04182" y="35.625" width="60.7054" height="93.1299">
          <div
            style={{ backdropFilter: 'blur(5.51px)', clipPath: 'url(#bgblur_2_5622_26054_clip_path)', height: '100%', width: '100%' }}
          ></div>
        </foreignObject>
        <g
          filter="url(#filter1_d_5622_26054)"
          data-figma-bg-blur-radius="11.0118"
        >
          <rect
            x="18.3359"
            y="46.6367"
            width="38.1176"
            height="69.8824"
            rx="8.47059"
            fill="white"
            fill-opacity="0.01"
            shape-rendering="crispEdges"
          />
          <rect
            x="18.6889"
            y="46.9897"
            width="37.4118"
            height="69.1765"
            rx="8.11765"
            stroke="white"
            stroke-width="0.705882"
            shape-rendering="crispEdges"
          />
        </g>
        <rect
          x="21.1582"
          y="49.4609"
          width="32.4706"
          height="64.2353"
          rx="7.05882"
          fill="#EFEEFF"
        />
        <rect
          x="24.2178"
          y="64.9902"
          width="26.8235"
          height="44.2353"
          rx="2.82353"
          fill="white"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M27.2209 89.9316H31.5648C31.9247 89.9316 32.2164 90.2234 32.2164 90.5832V94.9271C32.2164 95.287 31.9247 95.5787 31.5648 95.5787H27.2209C26.8611 95.5787 26.5693 95.287 26.5693 94.9271V90.5832C26.5693 90.2234 26.8611 89.9316 27.2209 89.9316ZM30.9144 91.9813C31.0268 91.8408 31.004 91.6358 30.8635 91.5234C30.723 91.411 30.518 91.4338 30.4056 91.5743L28.8653 93.4996L28.2491 93.0375C28.1052 92.9296 27.901 92.9587 27.793 93.1027C27.685 93.2466 27.7142 93.4508 27.8582 93.5588L28.7269 94.2104C28.8677 94.316 29.0669 94.2906 29.1768 94.1533L30.9144 91.9813Z"
          fill="#330066"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M27.2209 101.225H31.5648C31.9247 101.225 32.2164 101.516 32.2164 101.876V106.22C32.2164 106.58 31.9247 106.872 31.5648 106.872H27.2209C26.8611 106.872 26.5693 106.58 26.5693 106.22V101.876C26.5693 101.516 26.8611 101.225 27.2209 101.225ZM30.9144 103.274C31.0268 103.134 31.004 102.929 30.8635 102.816C30.723 102.704 30.518 102.727 30.4056 102.867L28.8653 104.793L28.2491 104.33C28.1052 104.223 27.901 104.252 27.793 104.396C27.685 104.54 27.7142 104.744 27.8582 104.852L28.7269 105.503C28.8677 105.609 29.0669 105.584 29.1768 105.446L30.9144 103.274Z"
          fill="#330066"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M29.3929 84.2838C30.9523 84.2838 32.2164 83.0196 32.2164 81.4602C32.2164 79.9009 30.9523 78.6367 29.3929 78.6367C27.8335 78.6367 26.5693 79.9009 26.5693 81.4602C26.5693 83.0196 27.8335 84.2838 29.3929 84.2838ZM29.645 80.0485C29.645 79.9093 29.5321 79.7964 29.3929 79.7964C29.2536 79.7964 29.1408 79.9093 29.1408 80.0485V81.4602C29.1408 81.5995 29.2536 81.7123 29.3929 81.7123H30.4013C30.5405 81.7123 30.6534 81.5995 30.6534 81.4602C30.6534 81.321 30.5405 81.2081 30.4013 81.2081H29.645V80.0485Z"
          fill="#FFCC00"
        />
        <rect
          x="34.3359"
          y="68.2852"
          width="8.47059"
          height="1.41176"
          rx="0.705882"
          fill="#EFEEFF"
        />
        <rect
          x="34.3359"
          y="79.5781"
          width="8.47059"
          height="1.41176"
          rx="0.705882"
          fill="#EFEEFF"
        />
        <rect
          x="34.3359"
          y="90.873"
          width="8.47059"
          height="1.41176"
          rx="0.705882"
          fill="#EFEEFF"
        />
        <rect
          x="34.3359"
          y="102.166"
          width="8.47059"
          height="1.41176"
          rx="0.705882"
          fill="#EFEEFF"
        />
        <rect
          x="34.3359"
          y="70.6367"
          width="5.17647"
          height="1.41176"
          rx="0.705882"
          fill="#EFEEFF"
        />
        <rect
          x="34.3359"
          y="81.9316"
          width="5.17647"
          height="1.41176"
          rx="0.705882"
          fill="#EFEEFF"
        />
        <rect
          x="34.3359"
          y="93.2266"
          width="5.17647"
          height="1.41176"
          rx="0.705882"
          fill="#EFEEFF"
        />
        <rect
          x="34.3359"
          y="104.52"
          width="5.17647"
          height="1.41176"
          rx="0.705882"
          fill="#EFEEFF"
        />
        <rect
          x="26.0996"
          y="75.3438"
          width="23.0588"
          height="0.941176"
          rx="0.470588"
          fill="#EFEEFF"
        />
        <rect
          x="26.0996"
          y="86.6367"
          width="23.0588"
          height="0.941176"
          rx="0.470588"
          fill="#EFEEFF"
        />
        <rect
          x="26.0996"
          y="97.9316"
          width="23.0588"
          height="0.941176"
          rx="0.470588"
          fill="#EFEEFF"
        />
        <rect
          x="45.8643"
          y="68.7559"
          width="2.82353"
          height="2.82353"
          rx="1.41176"
          fill="#CCCCFF"
        />
        <rect
          x="45.8643"
          y="80.0469"
          width="2.82353"
          height="2.82353"
          rx="1.41176"
          fill="#CCCCFF"
        />
        <rect
          x="45.8643"
          y="91.3438"
          width="2.82353"
          height="2.82353"
          rx="1.41176"
          fill="#CCCCFF"
        />
        <rect
          x="45.8643"
          y="102.639"
          width="2.82353"
          height="2.82353"
          rx="1.41176"
          fill="#CCCCFF"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M28.1347 67.5346C28.2569 67.4124 28.4226 67.3438 28.5954 67.3438H30.1903C30.3631 67.3438 30.5289 67.4124 30.6511 67.5346L32.0256 68.9091C32.1478 69.0313 32.2164 69.197 32.2164 69.3698V70.9647C32.2164 71.1375 32.1478 71.3033 32.0256 71.4255L30.6511 72.8C30.5289 72.9222 30.3631 72.9908 30.1903 72.9908H28.5954C28.4226 72.9908 28.2569 72.9222 28.1347 72.8L26.7602 71.4255C26.638 71.3033 26.5693 71.1375 26.5693 70.9647V69.3698C26.5693 69.197 26.638 69.0313 26.7602 68.9091L28.1347 67.5346ZM29.3929 68.484C29.5728 68.484 29.7187 68.6299 29.7187 68.8098V70.2216C29.7187 70.4015 29.5728 70.5474 29.3929 70.5474C29.2129 70.5474 29.0671 70.4015 29.0671 70.2216V68.8098C29.0671 68.6299 29.2129 68.484 29.3929 68.484ZM29.8273 71.4162C29.8273 71.6561 29.6328 71.8505 29.3929 71.8505C29.153 71.8505 28.9585 71.6561 28.9585 71.4162C28.9585 71.1763 29.153 70.9818 29.3929 70.9818C29.6328 70.9818 29.8273 71.1763 29.8273 71.4162Z"
          fill="#FF0099"
        />
        <rect
          x="21.1582"
          y="49.4609"
          width="32.4706"
          height="11.2941"
          rx="5.64706"
          fill="white"
        />
        <rect
          x="26.8057"
          y="55.8125"
          width="21.1765"
          height="2.82353"
          rx="1.41176"
          fill="#EFEEFF"
        />
        <rect
          x="23.9824"
          y="51.5801"
          width="4.23529"
          height="1.41176"
          rx="0.705882"
          fill="#EFEEFF"
        />
        <rect
          x="32.4531"
          y="50.873"
          width="9.88235"
          height="2.82353"
          rx="1.41176"
          fill="#EFEEFF"
        />
        <rect
          x="49.3936"
          y="51.5801"
          width="2.11765"
          height="1.41176"
          rx="0.705882"
          fill="#EFEEFF"
        />
        <rect
          x="45.8643"
          y="51.5801"
          width="2.11765"
          height="1.41176"
          rx="0.705882"
          fill="#EFEEFF"
        />
      </g>
      <defs>
        <filter
          id="filter0_d_5622_26054"
          x="17.8641"
          y="16.5683"
          width="129.882"
          height="100.894"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="0.941176" />
          <feGaussianBlur stdDeviation="5.64706" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.13 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_5622_26054"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_5622_26054"
            result="shape"
          />
        </filter>
        <clipPath
          id="bgblur_1_5622_26054_clip_path"
          transform="translate(-17.8641 -16.5683)"
        >
          <rect
            x="29.1582"
            y="27.5801"
            width="107.294"
            height="77.6471"
            rx="11.2941"
          />
        </clipPath>
        <filter
          id="filter1_d_5622_26054"
          x="7.04182"
          y="35.625"
          width="60.7054"
          height="93.1299"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="0.941176" />
          <feGaussianBlur stdDeviation="5.64706" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.13 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_5622_26054"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_5622_26054"
            result="shape"
          />
        </filter>
        <clipPath
          id="bgblur_2_5622_26054_clip_path"
          transform="translate(-7.04182 -35.625)"
        >
          <rect
            x="18.3359"
            y="46.6367"
            width="38.1176"
            height="69.8824"
            rx="8.47059"
          />
        </clipPath>
        <clipPath id="clip0_5622_26054">
          <rect width="160" height="124.235" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}

export default MedicationBlob
